import { Avatar } from 'antd-mobile';
import { IAiChatBubble } from '@/types/.component.ts';
import classnames from 'classnames';
import Markdown from 'react-markdown';
import _ from 'lodash';

export default function AiChatBubble(props: IAiChatBubble) {
    const { onStop, children, avatar = '/assets/images/icon_avatar.svg', pending, right } = props;

    const renderContent = () => {
        if (children && _.isString(children)) return <Markdown>{children}</Markdown>;
        if (pending)
            return (
                <div className="loading-container">
                    <div className="loading"></div>
                </div>
            );
    };

    return (
        <div className={classnames('flex w-full items-start gap-3', { 'flex-row-reverse': right })}>
            <Avatar className="flex-shrink-0 rounded-full" src={avatar} style={{ '--size': '2.5rem' }}></Avatar>
            <div className={classnames('flex flex-grow gap-x-2', { 'justify-end': right })}>
                <div
                    className={classnames(
                        'rounded-lg bg-white p-3 text-sm shadow',
                        right ? 'rounded-tr-none' : 'rounded-tl-none',
                        { '!bg-[#4B40F3] text-white': right },
                    )}
                >
                    {renderContent()}
                </div>
                {pending ? (
                    <img src="/assets/images/icon_aichat_stop.png" className="h-4 w-4" alt="" onClick={onStop} />
                ) : null}
            </div>
        </div>
    );
}
